<template>
  <div class="contact-us-container">
    <h1>Contact Us</h1>
    <br />
    <div class="flex-container">
      <div class="inside-container">
        <h3>Lifestyle Developers</h3>
        <br>
        <div>
          <span style="font-weight:bold">Address : </span> Tulsi apartment, opposite to Morya hospital,
          9th lane, Rajarampuri, Kolhapur.
        </div>
        <br />
        <div>
          <span style="font-weight:bold">Branch : </span> - Vimal Visava, Rajarshi Shahu colony, near Hotel Neelkamal,
          Gadhinglaj-Sankeshwar Road, Gadhinglaj.
        </div>
        <br />
        <div>Lifestyledevelopers.kop@gmail.com</div>
        <div>+91 9822840096</div>
        <div>+91 8237629111</div>
      </div>
      <div class="form-container">
        <form
          id="my-form"
          action="https://formspree.io/meqryago"
          method="POST"
          @submit.prevent="formSubmit"
        >
          <input
            type="text"
            v-model="name"
            name="name"
            placeholder="Your name.."
          />

          <input
            type="email"
            v-model="email"
            name="email"
            id="fname"
            placeholder="Your email.."
          />

          <input
            type="text"
            v-model="phone"
            name="phone"
            placeholder="Mobile.."
          />

          <textarea
            v-model="message"
            name="message"
            placeholder="Write something.."
            style="height:15vh"
          ></textarea>

          <button id="my-form-button">Submit</button>
          <p class="response-message" id="my-form-status"></p>
        </form>
      </div>
    </div>

    <br />
  </div>
</template>

<script>
export default {
  data: function() {
    return {
      email: "",
      message: "",
      phone: "",
      name: "",
    };
  },
  methods: {
    formSubmit: function() {
      var form = document.getElementById("my-form");
      var status = document.getElementById("my-form-status");

      function success() {
        form.reset();
        status.innerHTML = "Thanks! We will get back to you.";
      }

      function error() {
        status.innerHTML = "Oops! There was a problem.";
      }

      var data = new FormData(form);
      this.ajax(form.method, form.action, data, success, error);
    },
    ajax: function(method, url, data, success, error) {
      var xhr = new XMLHttpRequest();
      xhr.open(method, url);
      // xhr.open(method, url);
      xhr.setRequestHeader("Accept", "application/json");
      xhr.onreadystatechange = function() {
        if (xhr.readyState !== XMLHttpRequest.DONE) return;
        if (xhr.status === 200) {
          success(xhr.response, xhr.responseType);
        } else {
          error(xhr.status, xhr.response, xhr.responseType);
        }
      };
      xhr.send(data);
    },
  },
};
</script>

<style scoped>
* {
  /*background: black;*/
  /*border: 1px solid red   ;*/
}

.response-message {
  padding-top: 10px;
}

/* Style inputs with type="text", select elements and textareas */
input[type="email"],
input[type="text"],
select,
textarea {
  width: 100%; /* Full width */
  padding: 12px; /* Some padding */
  border: 1px solid #ccc; /* Gray border */
  border-radius: 4px; /* Rounded borders */
  box-sizing: border-box; /* Make sure that padding and width stays in place */
  margin-top: 6px; /* Add a top margin */
  margin-bottom: 16px; /* Bottom margin */
  resize: vertical; /* Allow the user to vertically resize the textarea (not horizontally) */
}

/* Style the submit button with a specific background color etc */
button {
  background-color: #4caf50;
  color: white;
  padding: 12px 20px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  display: inline-block;
}

/* When moving the mouse over the submit button, add a darker green color */
input[type="submit"]:hover {
  background-color: #45a049;
}

.contact-us-container {
  padding-top: 20vh;
  padding-left: 10vw;
  padding-bottom: 10vh;
  padding-right: 10vw;
  background-image: url("../assets/Crane.png");
  background-repeat: no-repeat;
  background-position-y: 13vh !important;
  background-position: right;
  background-size: 600px 85vh;
}
.flex-container {
  display: flex;
}

.inside-container {
}
.form-container {
  margin-left: 2vw;
  padding-right: 15vw;
}

@media screen and (max-width: 500px) {
  .contact-us-container {
    background-image: none;
    /*background-repeat: no-repeat;*/
    /*background-position-y: 10vh;*/
    /*background-position-x: 22vw;*/
    /*background-size: 162%;*/
    margin-bottom: 0;
    padding-bottom: 0;
  }
  .flex-container {
    display: flex;
    flex-direction: column;
  }
  .form-container {
    margin-left: 0;
    margin-top: 10px;
    padding-right: 0;
  }
}
</style>
